import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isCartDrawerOpen: false,
  toast: {
    message: '',
    visible: false,
    type: 'success', // success, error, info
  }
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openCartDrawer: (state) => {
      state.isCartDrawerOpen = true;
    },
    closeCartDrawer: (state) => {
      state.isCartDrawerOpen = false;
    },
    toggleCartDrawer: (state) => {
      state.isCartDrawerOpen = !state.isCartDrawerOpen;
    },
    showToast: (state, action) => {
      state.toast.message = action.payload.message;
      state.toast.type = action.payload.type || 'success';
      state.toast.visible = true;
    },
    hideToast: (state) => {
      state.toast.visible = false;
    },
  },
});

export const { openCartDrawer, closeCartDrawer, toggleCartDrawer, showToast, hideToast } = uiSlice.actions;
export default uiSlice.reducer;
